import { createRoot } from 'react-dom/client';
import { App } from './app';
import { captureCustomerCodeFromUrl } from './processes/CMS/processes/management/pages/PreviewPage/lib/prefill';

// Before the routers: the customer code from the finder link has to be read while it is still in
// the address, and the address itself has to be left without it.
captureCustomerCodeFromUrl();

const root = createRoot(document.querySelector('#root'));
root.render(<App />);
